import { Seo } from "./index";
import { PageHeader } from "./PagesComponents";
import { useEffect } from "react";
import { useRouter } from "next/router";

export default function Redirect({ redirectTo }) {
  const router = useRouter();
  useEffect(() => {
    router.replace(redirectTo || "/", redirectTo || "/", {
      locale: router.locale,
    });
  }, [router, redirectTo]);
  return (
    <>
      <Seo />
      <PageHeader />
    </>
  );
}
